const separa_em_area_corporativa = (
  arr = [],
  area = 0,
  wantWorkshops = true
) => {
  let sigma = [];
  let excelencia = [];
  let sistemas = [];
  let softwares = [];
  let agil = [];
  let lideres = [];
  let vendas = [];
  let projetos = [];
  let workshops = [];
  if (arr.length > 0) {
    arr
      .filter((cs) => cs)
      .forEach((cs) => {
        if (cs.id == 3199) {
          // especialista en green belt
          cs.descontoBlack = 45;
        }
        if (cs.id == 3779) {
          // analise estatísticas no minitab 18
          cs.descontoBlack = 30;
        }

        if (cs.id == 3252) {
          // estruturação de um sistema de gestão para resultados
          cs.descontoBlack = 30;
        }

        //QUARENTENA
        if (cs.id == 3560) {
          // day 1
          cs.descontoBlack = 100;
        }

        if (cs.id == 3238) {
          // day 2
          cs.descontoBlack = 100;
        }

        if (cs.id == 3497) {
          //day 3
          cs.descontoBlack = 100;
        }

        if (cs.id == 4111) {
          //day 5
          cs.descontoBlack = 100;
        }

        if (cs.id == 1409) {
          //day 4
          cs.descontoBlack = 100;
        }

        if (cs.id == 4136) {
          //day 6
          cs.descontoBlack = 100;
        }

        if (cs.id == 3247) {
          //day 7
          cs.descontoBlack = 100;
        }

        if (cs.id == 4114) {
          //day 8
          cs.descontoBlack = 100;
        }

        if (cs.id == 3640) {
          //day 9
          cs.descontoBlack = 100;
        }

        if (cs.id == 4108) {
          cs.descontoBlack = 100;
        }

        if (cs.id == 3641) {
          cs.descontoBlack = 100;
        }

        if (parseInt(cs.area_corporativo) == 1) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            sigma.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 2) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            excelencia.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 3) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            softwares.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 4) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            sistemas.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 5) {
          if (
            wantWorkshops === true &&
            (cs.titulo.indexOf("Workshop") < 0 || cs.id == 4108)
          ) {
            agil.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 6) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            lideres.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 7) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            vendas.push(cs);
          }
        }
        if (parseInt(cs.area_corporativo) == 9) {
          if (wantWorkshops === true && cs.titulo.indexOf("Workshop") < 0) {
            projetos.push(cs);
          }
        }
        if (cs.titulo) {
          if (cs.titulo.toLowerCase().indexOf("workshop") > -1) {
            workshops.push(cs);
          }
        }
      });
  }

  if (area != 0) {
    switch (area) {
      case 1:
        return sigma;
        break;
      case 2:
        return excelencia;
        break;
      case 3:
        return softwares;
        break;
      case 4:
        return sistemas;
        break;
      case 5:
        return agil;
        break;
      case 6:
        return lideres;
        break;
      case 7:
        return vendas;
        break;
      case 9:
        return projetos;
      case 10:
        return workshops;
        break;
    }
  }

  return {
    sigma,
    excelencia,
    softwares,
    sistemas,
    agil,
    lideres,
    vendas,
    projetos,
    workshops,
  };
};
export default separa_em_area_corporativa;
